import * as actionTypes from "../../../../actions/actionTypes";
import {updateObject} from "../../../../../utils/utils";

const initialState = {

    loading : true,
    error : null,
    listeCours: []

};

const etudiantMesCoursFetchListeCoursStart = (state,action) => {
    return updateObject(state,{
        loading:true,
        error:null,
        listeCours: []
    });
};

const etudiantMesCoursFetchListeCoursSuccess = (state,action) => {
    return updateObject(state,{
        loading:false,
        error:null,
        listeCours: action.payload.listeCours
    });
};

const etudiantMesCoursFetchListeCoursFail = (state,action) => {
    return updateObject(state,{
        loading:false,
        error:action.payload.error,
        listeCours: []
    });
};

const etudiantMesCoursFetchListeCoursReset = (state,action) => {
    return updateObject(state,initialState);
};



const reducer = (state = initialState,action) => {
    switch (action.type) {

        case actionTypes.ETUDIANT_MES_COURS_FETCH_LISTE_COURS_START : return etudiantMesCoursFetchListeCoursStart(state,action);
        case actionTypes.ETUDIANT_MES_COURS_FETCH_LISTE_COURS_SUCCESS : return etudiantMesCoursFetchListeCoursSuccess(state,action);
        case actionTypes.ETUDIANT_MES_COURS_FETCH_LISTE_COURS_FAIL : return etudiantMesCoursFetchListeCoursFail(state,action);
        case actionTypes.ETUDIANT_MES_COURS_FETCH_LISTE_COURS_RESET : return etudiantMesCoursFetchListeCoursReset(state,action);
        default : return state;
    }
};

export default reducer;